const trimAll = (value: string) => {
  return value.trim().replace(/\s+/g, ' ');
};

export default trimAll;
